export { useColorScheme } from 'nativewind';
